import {Api} from '@/core/api.js';
const api = new Api();

// initial state

let sizes = {};
if (process.env.VUE_APP_MARKET == 'PT') {
    sizes = {
        "-1":{},
        "1": {
            1: {id: 1, name: 'Poster - A4 (21x29,7cm)', custom: false},
            2: {id: 2, name: 'Poster - A3 (29,7x42cm)', custom: false},
            3: {id: 3, name: 'Poster - 70x100cm', custom: false},
            4: {id: 4, name: 'Rollup - 85x200cm', custom: false},
            5: {id: 5, name: 'Pendurante - 50cmØ', custom: false},
            6: {id: 6, name: 'Sreensaver SOK - 1080x1920px', custom: false},
            7: {id: 7, name: 'Orelha SOK Quadrada - 113,4x50cm', custom: false},
            8: {id: 8, name: 'Orelha SOK Redonda - 113,4x39,5cm', custom: false},
            9: {id: 9, name: 'Topo SOK - 59x26cm', custom: false},
            10: {id: 10, name: 'Lateral SOK - 25x85cm', custom: false},
            11: {id: 11, name: 'Autoc. Mesa - 8,5cmØ', custom: false},
            12: {id: 12, name: 'Autoc. Saco - 6cmØ', custom: false},
            13: {id: 13, name: 'Outro', custom: false}
        },
        "2": {
            1: {id: 1, name: 'Infoboard - 71x122cm', custom: false},
            2: {id: 2, name: 'Presell 71x175cm', custom: false},
            3: {id: 3, name: 'Lona 4x1m', custom: false},
            4: {id: 4, name: 'Lona 4x2m', custom: false},
            5: {id: 5, name: 'Janela Autoc Peq - 28x40cm', custom: false},
            6: {id: 6, name: 'Janela Autoc - 36x71cm', custom: false},
            7: {id: 7, name: 'Outro', custom: false}
        },
        "3": {
            1: {id: 1, name: 'Flyer - A5(14,8x21cm)', custom: false},
            2: {id: 2, name: 'Mupe - 160x40cm', custom: false},
            3: {id: 3, name: 'Mupe - 150x30cm', custom: false},
            4: {id: 4, name: 'Mupi - 118,5x175cm', custom: false},
            5: {id: 5, name: 'Mupi - 120x175cm', custom: false},
            6: {id: 6, name: 'Mini - 240x170cm', custom: false},
            7: {id: 7, name: 'Senior - 320x235cm', custom: false},
            8: {id: 8, name: 'Outdoor - 4x3m', custom: false},
            9: {id: 9, name: 'Outdoor - 8x3m', custom: false},
            10: {id: 10, name: 'Monoposte - 8x4m', custom: false},
            11: {id: 11, name: 'Monoposte - 10x4m', custom: false},
            12: {id: 12, name: 'Monoposte - 10x5m', custom: false},
            13: {id: 13, name: 'Monoposte - 11x5m', custom: false},
            14: {id: 14, name: 'Monoposte - 12x5m', custom: false},
            15: {id: 15, name: 'Monoposte - 14x5m', custom: false},
            16: {id: 16, name: 'Caixa Luz Superior - 400x65cm', custom: false},
            17: {id: 17, name: 'Tarjeta (85 x 55 mm)', custom: false},
            18: {id: 18, name: 'Outro', custom: false}
        },
        "4": {
            1: {id: 1, name: 'Post - 1080x1080px', custom: false},
            2: {id: 2, name: 'Story - 1080x1920px', custom: false},
            3: {id: 3, name: 'SOK Dig - 1080x1920px', custom: false},
            4: {id: 4, name: 'MOP Dig - 1920x1080px', custom: false},
            5: {id: 5, name: 'Billboard - 970x250px', custom: false},
            6: {id: 6, name: 'Mobile Interstitial - 320x480px', custom: false},
            7: {id: 7, name: 'Half-Page - 300x600px', custom: false},
            8: {id: 8, name: 'Mrec - 300x250px', custom: false},
            9: {id: 9, name: 'Bumper Ad - 300x60px', custom: false},
            10: {id: 10, name: 'Ecrã Digital - 2160x1920px', custom: false},
            11: {id: 11, name: 'Ecrã Digital - 768x576px', custom: false},
            12: {id: 12, name: 'Ecrã Digital - 650x420px', custom: false},
            13: {id: 13, name: 'Ecrã Digital - 540x360px', custom: false},
            14: {id: 14, name: 'Ecrã Digital - 512x768px', custom: false},
            15: {id: 15, name: 'Ecrã Digital - 448x320px', custom: false},
            16: {id: 16, name: 'Ecrã Digital - 384x640px', custom: false},
            17: {id: 17, name: 'Ecrã Digital - 384x384px', custom: false},
            18: {id: 18, name: 'Outro', custom: false}

        }
    }
} else {
    sizes = {
        "-1":{},
        "1": {
            1: {id: 1, name: 'MUPI 120x175cm 4/0', custom: false},
            2: {id: 2, name: 'MUPI senior 31 3x203cm 4/0', custom: false},
            3: {id: 3, name: 'MUPI mini 4x1,56cm 4/0', custom: false},
            4: {id: 4, name: 'MUPI otras dimensiones', custom: true},
        },
        "2": {
            1: {id: 1, name: 'Valla 8x3m. 4/0', custom: false},
            2: {id: 2, name: 'Valla 4x3m. 4/0', custom: false},
            3: {id: 3, name: 'Valla otras medidas 4/0', custom: true}
        },
        "3": {
            1: {id: 1, name: 'Vinilo normal, adhesivo cara no impresa', custom: true},
            2: {id: 2, name: 'Vinilo fondeado con adhesivo en cara impresa', custom: true},
            3: {id: 3, name: 'Vinilo doble cara', custom: true},
            4: {id: 4, name: 'Vinilo de corte', custom: true},
            5: {id: 5, name: 'Vinilo microperforado normal con adhesivo en cara no impresa', custom: true},
            // 6: {id: 6, name: 'Vinilo microferforado con adhesivo en cara impresa', custom: true},
        },
        "4": {
            1: {id: 1, name: 'Póster 70x100 4/0', custom: false},
            2: {id: 2, name: 'Póster otras dimensiones 4/0', custom: true},
        },
        "5": {
            1: {id: 1, name: 'Pieza de mesa 15,5x21 4/4', custom: false},
            2: {id: 2, name: 'Pieza de mesa otras dimensiones 4/4', custom: true},
        },
        "6": {
            1: {id: 1, name: 'Pieza de mostrador 24,5x35 4/0', custom: false},
            2: {id: 2, name: 'Pieza de mostrador otras dimensiones 4/0', custom: true},
        },
        "7": {
            1: {id: 1, name: 'Stopper 23x40 4/4', custom: false},
            2: {id: 2, name: 'Stopper otras dimensiones 4/4', custom: true},
        },
        "8": {
            1: {id: 1, name: 'Octavilla A5 4/0', custom: false},
            2: {id: 2, name: 'Octavilla A5 4/4', custom: false},
            3: {id: 3, name: 'Octavilla A6 4/0', custom: false},
            4: {id: 4, name: 'Octavilla A6 4/4', custom: false},
            5: {id: 5, name: 'Octavilla otras dimensiones 4/0', custom: true},
            6: {id: 6, name: 'Octavilla otras dimensiones 4/4', custom: true},
        },
        "9": {
            1: {id: 1, name: 'Díptico A5 cerrado 4/4', custom: false},
            2: {id: 2, name: 'Díptico otras medidas 4/4', custom: true},
        },
        "10": {
            1: {id: 1, name: 'Tríptico A5 cerrado 4/4', custom: false},
            2: {id: 2, name: 'Tríptico otras medidas 4/4', custom: true},
        },
        "11": {
            1: {id: 1, name: 'Bog 8,5x5,5cm 4/4', custom: false},
            2: {id: 2, name: 'Bog 8,5x5,5cm 4/0', custom: false},
            3: {id: 3, name: 'Bog otras medidas 4/4', custom: true},
            4: {id: 4, name: 'Bog otras medidas 4/0', custom: true},
        },
        "12": {
            1: {id: 1, name: 'Monoposte 12x5m 4/0', custom: false},
            2: {id: 2, name: 'Monoposte 12x3mm 4/0', custom: false},
            3: {id: 3, name: 'Monoposte otras medidas 4/0', custom: true},
        },
        "13": {
            1: {id: 1, name: 'Pieza critaleria 68x98 4/4', custom: false},
            2: {id: 1, name: 'Pieza critaleria 68x98 4/0', custom: false},
            3: {id: 2, name: 'Pieza cristaleria otras medidas 4/4', custom: true},
            4: {id: 2, name: 'Pieza cristaleria otras medidas 4/0', custom: true},
        },
        "14": {
            1: {id: 1, name: 'FS paravent 55x55 4/0', custom: false},
            2: {id: 2, name: 'FS paravent otras medidas 4/0', custom: true},
        },
        "15": {
            1: {id: 1, name: 'Presell 71x175 4/0', custom: false},
            2: {id: 2, name: 'Presell otras medidas', custom: true},
        },
        "16": {
            1: {id: 1, name: 'Medidas personalizadas', custom: true},
        },
        "17": {
            1: {id: 1, name: 'Roll up 85x210cm 4/0', custom: false},
            // 2: {id: 2, name: 'Roll up 80x200cm 4/0', custom: false},
            3: {id: 3, name: 'Roll up 100x210cm 4/0', custom: false},
            // 4: {id: 4, name: 'Roll up 100x200 4/0', custom: false},
            5: {id: 5, name: 'Roll up otras dimensiones 4/0', custom: true},
        },
        "18": {
            1: {id: 1, name: 'Cartón pluma 50x150 4/4', custom: false},
            2: {id: 2, name: 'Cartón pluma 80x150 4/4', custom: false},
            3: {id: 3, name: 'Cartón pluma otras dimensiones 4/4', custom: true},
        },
        "19": {
            1: {id: 1, name: 'Lisa 4/0', custom: true},
            2: {id: 2, name: 'Lisa 4/4', custom: true},
            4: {id: 4, name: 'Microperforada 4/0', custom: true},
        },
        "20": {
            1: {id: 1, name: 'Metacrilato A4 4/0', custom: false},
            2: {id: 2, name: 'Metacrilato otras medidas 4/0', custom: true},
        },
        "21": {
            1: {id: 1, name: 'Vinilo A4 4/4', custom: false},
            2: {id: 2, name: 'Vinilo A4 4/0', custom: false},
            3: {id: 3, name: 'Vinilo A4 0/4 (adhesivo cara impresa)', custom: false},
            4: {id: 4, name: 'Vinilo 15X15 4/4', custom: false},
            5: {id: 5, name: 'Vinilo 15X15 4/0', custom: false},
            6: {id: 6, name: 'Vinilo 15x15 0/4 (adhesivo cara impresa)', custom: false},
            7: {id: 7, name: 'Vinilo 15x12 4/4', custom: false},
            8: {id: 8, name: 'Vinilo 15x12 4/0', custom: false},
            9: {id: 9, name: 'Vinilo 15x12 0/4 (adhesivo cara impresa)', custom: false},
            10: {id: 10, name: 'Vinilo A5 4/4', custom: false},
            11: {id: 11, name: 'Vinilo A5 4/0', custom: false},
            12: {id: 12, name: 'Vinilo A5 0/4 (adhesivo cara impresa)', custom: false},
            13: {id: 13, name: 'Vinilo otras medidas 4/4', custom: true},
            14: {id: 14, name: 'Vinilo otras medidas 4/0', custom: true},
            15: {id: 15, name: 'Vinilo otras medidas 0/4 (adhesivo cara impresa)', custom: true},
        },
        "22": {
            1: {id: 1, name: 'Bandera doble 150x400 4/4', custom: false},
            2: {id: 2, name: 'Bandera simple 150x400 4/0', custom: false},
            3: {id: 3, name: 'Bandera otras medidas 4/0', custom: true},
        },
        "23": {
            1: {id: 1, name: 'Invitación papel 21x10cm 4/0', custom: false},
            2: {id: 2, name: 'Invitación papel 21x10 4/4', custom: false},
            3: {id: 3, name: 'Invitación digital 21x148', custom: false},
            4: {id: 4, name: 'Invitación papel otras medidas 4/0', custom: true},
            5: {id: 5, name: 'Invitación papel otras medidas 4/4', custom: true},
        },
        "24": {
            1: {id: 1, name: 'Vinilo ventana McAuto 40x40 4/4', custom: false},
            2: {id: 2, name: 'Vinilo ventana McAuto 40x40 4/0', custom: false},
            3: {id: 3, name: 'Vinilo precios McAuto 40x40 0/4 (adhesivo cara impresa)', custom: false},
            4: {id: 4, name: 'Vinilo ventana McAuto otras medidas 4/4', custom: true},
            5: {id: 5, name: 'Vinilo ventana McAuto otras medidas 4/0', custom: true},
            6: {id: 6, name: 'Vinilo precio McAuto otras medidas 0/4 (adhesivo cara impresa)', custom: true},
        },
        "25": {
            1: {id: 1, name: 'Póster precio restaurante 68x98 4/0', custom: false},
            2: {id: 2, name: 'Póster precio restaurante otras medidas 4/0', custom: true},
        },
        "26": {
            1: {id: 1, name: 'Tira bajo menú 55x18cm 4/0', custom: false},
            2: {id: 2, name: 'Tira bajo menú doble 98x18cm 4/0', custom: false},
            // 3: {id: 3, name: 'Tira bajo menú ( Ancho Translite ) 110x18cm4/0', custom: false},
            4: {id: 4, name: 'Tira bajo menú otras medidas 4/0', custom: true},
        },
        "27": {
            1: {id: 1, name: 'Translite Doble Menú Board 117x66,2cm 4/0', custom: false},
            2: {id: 2, name: 'Translite Individual Menú Board / McAuto 555x662cm 4/0', custom: false},
            3: {id: 3, name: 'Translite McAuto Especial (55) 55,5x55,5cm 4/0', custom: false},
            4: {id: 4, name: 'Translite otras medidas 4/0', custom: true},
        },
        "28": {
            1: {id: 1, name: 'Tarjeta 8,5x5,5cm 4/4', custom: false},
            2: {id: 2, name: 'Tarjeta 8,5x5,5cm 4/0', custom: false},
            3: {id: 3, name: 'Tarjeta otras medidas 4/4', custom: true},
            4: {id: 4, name: 'Tarjeta otras medidas 4/0', custom: true},
        },
        "29": {
            //BANNER NO EXISTE EN EL PDF
        },
        "30": {
            //FOTO PRODUCTO NO EXISTE EN EL PDF
        },
        "31": {
            //POST NO EXISTE EN EL PDF
        },
        "32": {
            //LOGOTIPO NO EXISTE EN EL PDF
        },
        "33": {
            //MANUAL NO EXISTE EN EL PDF
        },
        "34": {
            //GUIA NO EXISTE EN EL PDF
        },
        "35": {
            //MUSICA NO EXISTE EN EL PDF
        },
        "36": {
            //CUÑA NO EXISTE EN EL PDF
        },
        "37": {
            //TIPOGRAFIA NO EXISTE EN EL PDF
        },
        "38": {
            //VIDEO NO EXISTE EN EL PDF
        },
        "39": {
            //OTRA PIEZA NO EXISTE EN EL PDF
            1: {id: 1, name: 'Medidas personalizadas 4/0', custom: true},
            2: {id: 2, name: 'Medidas personalizadas 4/4', custom: true},
        },
        "40": {
            //PRESENTACIÓN NO EXISTE EN EL PDF
        }
    }
}
const state = {
    cart: {},
    orders: {},
    sizes: sizes,
    questions: {
        "-1":{},
        "1": {
            //MUPI
        },
        "2": {
            //VALLA
        },
        "3": {
            //VINILO
        },
        "4": {
            //POSTER
        },
        "5": {
            //PIEZA MESA
        },
        "6": {
            //PIEZA MOSTRADOR
        },
        "7": {
            //STOOPER
        },
        "8": {
            //OCTAVILLA
            q1: true
        },
        "9": {
            //DIPTICO
            q1: true
        },
        "10": {
            //TRIPTICO
            q1: true
        },
        "11": {
            //TARJETA/BOG
            q2: true
        },
        "12": {
            //MONOPOSTER
        },
        "13": {
            //PIEZA CRISTAL
        },
        "14": {
            //FS
        },
        "15": {
            //PRESELL
        },
        "16": {
            //PRENSA SIN TAMAÑOS
            q3: true
        },
        "17": {
            //ROLL UP
            q4: true
        },
        "18": {
            //CARTON PLUMA
            q5: true
        },
        "19": {
            //LONA
        },
        "20": {
            //METRACRILATO
        },
        "21": {
            //VINILO
        },
        "22": {
            //BANDERA
            q2: true
        },
        "23": {
            //INVITACION
            q6: true
        },
        "24": {
            //VINILO MCAUTO
        },
        "25": {
            //POSTER PRECIO REST
        },
        "26": {
            //TIRA BAJO MENU
        },
        "27": {
            //TANSLITE
        },
        "28": {
            //TARJETA FIDELIZA
            q2: true
        },
        "29": {
            //BANNER NO EXISTE EN EL PDF
        },
        "30": {
            //FOTO PRODUCTO NO EXISTE EN EL PDF
        },
        "31": {
            //POST NO EXISTE EN EL PDF
        },
        "32": {
            //LOGOTIPO NO EXISTE EN EL PDF
        },
        "33": {
            //MANUAL NO EXISTE EN EL PDF
        },
        "34": {
            //GUIA NO EXISTE EN EL PDF
        },
        "35": {
            //MUSICA NO EXISTE EN EL PDF
        },
        "36": {
            //CUÑA NO EXISTE EN EL PDF
        },
        "37": {
            //TIPOGRAFIA NO EXISTE EN EL PDF
        },
        "38": {
        //VIDEO NO EXISTE EN EL PDF
        },
        "39": {
            //OTRA PIEZA NO EXISTE EN EL PDF
            q8: true
        },
        "40": {
            //PRESENTACIÓN NO EXISTE EN EL PDF
        }
    },
    description: {
        "21": "Indica si necesitas realizar algún cambio/personalización en esta pieza. Por ejemplo: Horarios, empresa de seguridad, formas de pago, información de videovigilancia ( razón social y dirección social )",
        "20": "Indica si necesitas realizar algún cambio/personalización en esta pieza. Por ejemplo: Aforo.",
        "22": "Indica si necesitas realizar algún cambio/personalización en esta pieza. Por ejemplo: Extensión horario McAuto.",
        "23": "Indica si necesitas realizar algún cambio/personalización en esta pieza. Por ejemplo: nombre del anfitrión, día y hora de la fiesta, nombre y dirección del restaurante...",
        "24": "Indica la información que deseas personalizar en la pieza: Indica formas de pago, limitación horario venta de cervezas en McAuto...",
        "25": "Indica la información que deseas personalizar en la pieza: Indica formas de pago, limitación horario venta de cervezas en McAuto...",
    },
    personalization: {
        "24": true, //VINILO MCAUTO
        "25": true, //POSTER PRECIO REST
    },
    current_order: false,
    status: [],
    comments: {},
    unread_messages: false
}

// getters
const getters = {

    cartIsVisible: ( state, getters, rootState ) => {
        return Object.keys( state.cart ).length > 0;
    },

    getCart: (state, getters, rootState) => {
        return {...state.cart};
    },

    getCartLength: (state, getters, rootState) => {
        return Object.keys( state.cart ).length;
    },

    getSizes: (state, getters, rootState) => {
        return state.sizes;
    },

    getQuestions: (state, getters, rootState) => {
        return state.questions;
    },

    getPersonalizations: (state, getters, rootState) => {
        return state.personalization;
    },

    getDescriptions: (state, getters, rootState) => {
        return state.description;
    },

    getCurrentOrder: ( state, getters, rootState ) => {
        return state.current_order;
    },

    getOrders: ( state, getters, rootState ) => {
        return state.orders;
    },

    getOrderStatus: ( state, getters, rootState ) => {
        return state.status;
    },

    getComments: ( state, getters, rootState ) => (orderId) => {
        return state.comments[orderId] || [];
    },

    getUnreadMessages: ( state, getters, rootState ) => {
        return state.unread_messages;
    }

}

// actions
const actions = {

    loadCart( { commit } ){
        var cart = ( typeof localStorage.cart !== 'undefined' )? JSON.parse( localStorage.cart ) : {};

        commit( 'setCart', cart );
    },

    loadOrder( { commit }, id ){
        var order = state.cart[id];

        if( typeof order !== 'undefined' ){
            commit( 'setCurrentOrder', order );
        }
        else{
            commit( 'setCurrentOrder', false );
        }
    },

    uploadCart( { commit }, cart ) {
        console.log( cart );
        var uploadCart = {
            contact: cart.contact,
            items: []
        };

        for( var key in cart.items ){
            var item = {
                resource_id: cart.items[key].from.file,
                resource_type: cart.items[key].to.file,
                resource_type_format: cart.items[key].to.filename,
                resource_type_format_custom: cart.items[key].to.size,
                method: cart.items[key].method,
                units: ( cart.items[key].units )? cart.items[key].units : 0,
                units_scale: cart.items[key].units_scale,
                units_scale_custom: cart.items[key].units_scale_custom,
                billed: cart.items[key].billed,
                shipped: ( cart.items[key].shipped )? cart.items[key].shipped : -1,
                custom_ship: cart.items[key].custom_ship,
                custom_file: cart.items[key].custom_file,
                params: cart.items[key].params,
                custom: cart.items[key].custom,
                reference: cart.items[key].from.reference,
                link: cart.items[key].from.link
            };

            uploadCart.items.push( item );
        }

        return api.post( 'order/add', { order: JSON.stringify( uploadCart ) } ).then( function( data ){
            console.log( data );
            if( data.status ){
                console.log( data.data );
                commit( 'cleanCart' );
                return commit('addOrder', data.data );
            }
        });
        
    },

    loadOrders( { commit } ) {
        return api.get( 'order' ).then( function( data ){
            if( data.status ){
                return commit( 'setOrders', data.data );
            }
        });
    },

    uploadOrder( { commit }, order ) {
        return api.post( 'order/' + order.id + '/status', { status: order.status } ).then( function( data ){
            console.log( data );
            if( data.status ){
                return commit('addOrder', data.data );
            }
        });
    },

    removeOrder( { commit }, id ) {
        return api.get( 'order/' + id + '/delete' ).then( function( data ){
            console.log( data );
            if( data.status ){
                return commit( 'removeOrders', id );
            }
        });
    },

    loadComments( { commit }, id ) {
        return api.get( 'order/comments/' + id ).then( function( data ){
            if( data.status ){
                commit( 'setComments', { orderId: id, comments: data.data });
            }
        });
    },

    addComment( { commit }, comment ) {
        return api.post( 'order/comments/add', comment ).then( function( data ){
            if( data.status ){
                commit( 'addComment', { orderId: comment.order_id, comment: data.data });
                return data.data;
            }
        });
    },
    loadUnreadMessages: ({ commit }, userType) => {
        return api.get('order/unreadMessages/' + userType).then(function (data) {
            if (data.status) {
                commit('setUnreadMessages', data.data)
            }
        })
    },
    setReadMessages: ({ commit }, payload) => {
        return api.post('order/markAsRead', payload).then(function (data) {
            if (data.status) {
                commit('setUnreadMessages', data.data)
            }
        })
    },
    uploadImages: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            let urlArray = new Array(payload.images.length);
            let count = 0;
    
            for (let i = 0; i < payload.images.length; i++) {
                let uploaderFile = new Uploader();
                let currentFile = payload.images[i];
    
                uploaderFile.upload(
                    currentFile.file,
                    { 
                        path: 'files', 
                        filename: currentFile.name 
                    },
                    function (data) {
                        urlArray[i] = data.Location;
                        count++;
                        if (count === payload.images.length) {
                            api.post('order/uploadImages', {
                                id: payload.id,
                                image: urlArray.join(",")
                            }).then(response => {
                                resolve(response);
                            });
                        }
                    },
                    function (error) {
                        console.log(error);
                        reject(error);
                    }
                );
            }
        });
    }    
}

// mutations
const mutations = {

    setCart: function( state, cart ){
        state.cart = cart;
    },

    addOrderToCart: function( state, order ) {
        order.id = moment().valueOf() + "";

        var cart = {...state.cart};
        cart[order.id] = order;

        localStorage.setItem( 'cart', JSON.stringify( cart ) );
        state.cart = cart;
    },

    editOrder: function( state, order ) {
        var cart = {...state.cart};
        cart[order.id] = order;

        localStorage.setItem( 'cart', JSON.stringify( cart ) );
        state.cart = cart;
    },

    removeOrder: function( state, id ) {
        var cart = {...state.cart};

        delete cart[ id ];

        localStorage.setItem( 'cart', JSON.stringify( cart ) );
        state.cart = cart;
    },

    setCurrentOrder: function( state, order ){
        state.current_order = order;
    },

    setCurrentOrderByID: function( state, id ){
        state.current_order = state.orders[ id ];
    },

    cleanCart: function( state ){
        var cart = {};

        localStorage.setItem( 'cart', JSON.stringify( cart ) );
        state.cart = cart;
    },

    addOrder: function( state, order ){
        var orders = {...state.orders};
        
        orders[ order.id ] = order;

        state.orders = orders;
    },
    
    setOrders: function( state, orders ){
        state.orders = orders;
    },

    removeOrders( state, id ){
        var orders = {...state.orders};
        delete orders[ id ];

        state.orders = orders;
    },

    setComments: function( state, { orderId, comments } ){
        state.comments = {
            ...state.comments,
            [orderId]: comments
        };
    },

    addComment: function( state, { orderId, comment } ){
        const orderComments = state.comments[orderId] || [];
        state.comments = {
            ...state.comments,
            [orderId]: [...orderComments, comment]
        };
    },

    setUnreadMessages: function( state, unreadMessages ){
        if( unreadMessages > 0 ){
            state.unread_messages = true;
        }
        else{
            state.unread_messages = false;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}